var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"katex-mixed-text"},[_vm._l((_vm.parsedTexts),function(text){return [(text.isKatex)?[_c('katex-text',{staticClass:"katex-mixed-text__katex",attrs:{"src":text.value}})]:[_c('div',{staticClass:"katex-mixed-text__plain"},[_vm._v(_vm._s(text.value))])]]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }